//VJET definition of dependencies to other files (used for code assist only)
//< needs(ar.app)
'use strict';
/**
 * Controllers for the autoremind.profile feature
 */
/**
 * Screen controller for the profile page
 */
angular.module('autoremind.profile', [])
    .controller('autoremind.profile.ScreenController', ['$scope', '$http', '$location', 'logger', 'userProfile', 'dialogs', '$enhancedHttp', 'accountService', 'eventSharingService',
    function ($scope, $http, $location, logger, userProfile, dialogs, $enhancedHttp, accountService, eventSharingService) {
        // Initialize
        logger.info('In autoremind.profile.ScreenController');
        $scope.accountService = accountService;
        // TODO: Use shared model service and let it create structure if not there
        $scope.model = {};
        $scope.model.views = {};
        $scope.model.views.profile = {};
        $scope.model.views.profile.mobile = {};
        // TODO: Set only if not initialzed in the view model
        $scope.model.views.profile.mobileOn = 'false';
        // Map shared view model to this view
        $scope.profileViewModel = $scope.model.views.profile;
        // Map the services to the scope to access from the view
        $scope.userProfile = userProfile;
        $scope.hasAR3ReminderPermission = eventSharingService.hasPermission(['autoremind3:reminders']);
        $scope.hasAR3Permission = eventSharingService.hasPermission(['autoremind3']);
        $scope.profileViewModel.hourRange = [
            { 'label': '01', 'value': '1' },
            { 'label': '02', 'value': '2' },
            { 'label': '03', 'value': '3' },
            { 'label': '04', 'value': '4' },
            { 'label': '05', 'value': '5' },
            { 'label': '06', 'value': '6' },
            { 'label': '07', 'value': '7' },
            { 'label': '08', 'value': '8' },
            { 'label': '09', 'value': '9' },
            { 'label': '10', 'value': '10' },
            { 'label': '11', 'value': '11' },
            { 'label': '12', 'value': '12' },
            { 'label': '01', 'value': '13' },
            { 'label': '02', 'value': '14' },
            { 'label': '03', 'value': '15' },
            { 'label': '04', 'value': '16' },
            { 'label': '05', 'value': '17' },
            { 'label': '06', 'value': '18' },
            { 'label': '07', 'value': '19' },
            { 'label': '08', 'value': '20' },
            { 'label': '09', 'value': '21' },
            { 'label': '10', 'value': '22' },
            { 'label': '11', 'value': '23' }
        ];
        $scope.profileViewModel.maxRescheduleRange = [
            { 'label': '01', 'value': '1' },
            { 'label': '02', 'value': '2' },
            { 'label': '03', 'value': '3' },
            { 'label': '04', 'value': '4' },
            { 'label': '05', 'value': '5' },
            { 'label': '06', 'value': '6' },
            { 'label': '07', 'value': '7' },
            { 'label': '08', 'value': '8' },
            { 'label': '09', 'value': '9' },
            { 'label': '10', 'value': '10' },
            { 'label': '11', 'value': '11' },
            { 'label': '12', 'value': '12' },
            { 'label': '01', 'value': '13' },
            { 'label': '02', 'value': '14' },
            { 'label': '03', 'value': '15' },
            { 'label': '04', 'value': '16' },
            { 'label': '05', 'value': '17' },
            { 'label': '06', 'value': '18' },
            { 'label': '07', 'value': '19' },
            { 'label': '08', 'value': '20' },
            { 'label': '09', 'value': '21' },
            { 'label': '10', 'value': '22' },
            { 'label': '11', 'value': '23' }
        ];
        // $listStates = array("Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico","New York","North","Carolina","North","Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island","South","Carolina","South","Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington","West","Virginia","Wisconsin","Wyoming");
        //{AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California', CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia', FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', 'MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming'}
        $scope.profileViewModel.maxReschedule = '00';
        $scope.profileViewModel.intervalStopHour = '02';
        $scope.profileViewModel.intervalStopMin = '11';
        $scope.profileViewModel.intervalStartHour = '04';
        $scope.profileViewModel.intervalStartMin = '15';
        $scope.profileViewModel.intervalStartMeridiem = 'am';
        $scope.profileViewModel.intervalStopMeridiem = 'pm';
        //intervalstart="01:00" intervalstop="23:45"
        //$scope.url = 'http://localhost:8080/ar2proto/server/server.php?username=jb&password=test&test=list.json';
        //$scope.url = '../server/server.php?username=jb&password=test&command=getPatientList';
        $scope.url = 'servlets/autoremind/profile/';
        $scope.chargifyUrl = 'servlets/profile/chargify/subscriptions/';
        /*
         *  This will fetch profile data from the server (using a server) and update the UI
         */
        $scope.fetch = function () {
            logger.debug('ProfileController.fetch()');
            userProfile.getProfile(function (data, status) {
                //$scope.profileViewModel.status = status;
                //$scope.profileViewModel.account = userProfile.profileModel;
                // Split the block times to fit the UI
                var intervalSplit = userProfile.profileModel.intervalstart.split(":");
                var hour = intervalSplit[0];
                $scope.profileViewModel.intervalStartHour = String(hour % 12);
                if (hour < 12)
                    $scope.profileViewModel.intervalStartMeridiem = 'am';
                else
                    $scope.profileViewModel.intervalStartMeridiem = 'pm';
                $scope.profileViewModel.intervalStartMin = intervalSplit[1];
                intervalSplit = userProfile.profileModel.intervalstop.split(":");
                hour = intervalSplit[0];
                $scope.profileViewModel.intervalStopHour = String(hour % 12);
                if (hour < 12)
                    $scope.profileViewModel.intervalStopMeridiem = 'am';
                else
                    $scope.profileViewModel.intervalStopMeridiem = 'pm';
                $scope.profileViewModel.intervalStopMin = intervalSplit[1];
                logger.debug('intervalStartHour=' + $scope.profileViewModel.intervalStartHour);
                logger.debug('intervalStartMin=' + $scope.profileViewModel.intervalStartMin);
                logger.debug('intervalStopHour=' + $scope.profileViewModel.intervalStopHour);
                logger.debug('intervalStopMin=' + $scope.profileViewModel.intervalStopMin);
            });
            $enhancedHttp({ method: 'GET', url: $scope.chargifyUrl })
                .then(function (data, status) {
                userProfile.profileModel.chargify = data;
            }, function (data, status) {
                $scope.status = status;
                //TODO: Handle error better
            });
        };
        $scope.selectMaxReschedule = function () {
            logger.debut("max=" + userProfile.profileModel.maxreschedule);
            userProfile.saveMaxReschedule();
            // TODO: revert model and UI if saving failed (and display error)
        };
    }]);
//# sourceMappingURL=profile.controllers.js.map